
/**
 * @param {string} id
 * @param {number} interval
 * @param {object} options
 */
export const createTimedPulseAnimation = (id, interval, options = {}) => {
    const storeName = options.storeName || `animation_time-${id}`;
    const puleIcon = document.getElementById(id);
    const previousAnimationTime = Number(window.localStorage.getItem(storeName) || 0);
    if ((Date.now() - previousAnimationTime) > interval) {
        const onAnimate = () => {
            window.localStorage.setItem(storeName, String(Date.now()));
        };
        puleIcon.addEventListener('animationend', onAnimate);
        puleIcon.addEventListener('animationiteration', onAnimate);
        if (options.saveOnStart === true) {
            puleIcon.addEventListener('animationstart', onAnimate);
        }
        puleIcon.classList.add('pk-pulse-animation');
        if (options.times && options.times > 0) {
            puleIcon.classList.add(`pk-animation-${options.times}x`);
        }
    }
};

